import Table from "react-bootstrap/Table";
import copy from "copy-to-clipboard";
import dayjs from "dayjs";
import { HiClipboardCheck } from "react-icons/hi";
import Button from "react-bootstrap/Button";
import NumberFormat from "react-number-format";
import VehiclePhotos from "../VehiclePhotos";
import FreightBookingByVin from "./FreightBookingByVin";
import ReconReportComponent from "../Reconditioning/ReconReportComponent";

const StockCardSummaryRecon = ({ veh, yardLogs }) => {
  const copyToClipboard = (v) => {
    copy(v);
  };

  if (!veh) return null;

  return (
    <>
      <Table striped bordered hover size="sm">
        <thead>
          <tr>
            <th>Property</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody style={{ fontSize: 12 }}>
          <tr>
            <td>Stock No</td>
            <td>{veh.VEHStockNumber}</td>
          </tr>
          <tr>
            <td>Current Status</td>
            <td
              style={{
                backgroundColor:
                  veh?.CurrentStatus === "IN-STOCK" ? "#2ECC71" : "#D4E6F1",
                color: "black",
              }}
            >
              {veh.CurrentStatus}
            </td>
          </tr>
          <tr>
            <td>Year</td>
            <td>{veh.VEHModelYear}</td>
          </tr>
          <tr>
            <td>Make</td>
            <td>{veh.VEHMake}</td>
          </tr>
          <tr>
            <td>Model</td>
            <td>{veh.VEHmodel}</td>
          </tr>
          <tr>
            <td>Variant</td>
            <td>{veh["Variant"]}</td>
          </tr>
          <tr>
            <td>Colour</td>
            <td>{veh.VEHColour1}</td>
          </tr>
          <tr>
            <td>Odometer</td>
            <td>
              <NumberFormat
                displayType="text"
                thousandSeparator={true}
                value={veh.VEHOdo}
              />
            </td>
          </tr>
          <tr>
            <td>Branch / Dealership</td>
            <td>{veh.Branch}</td>
          </tr>
          <tr>
            <td>Current location / yard</td>
            <td>{veh.VEHYard}</td>
          </tr>

          <tr>
            <td>VIN</td>
            <td>
              {veh.VEHVIN}{" "}
              <Button
                onClick={() => copyToClipboard(veh.VEHVIN)}
                size="sm"
                variant="outline-dark"
              >
                <HiClipboardCheck size={20} />
              </Button>
            </td>
          </tr>
          <tr>
            <td>Age in stock</td>
            <td>
              {veh?.Age}
              &nbsp;day(s)
            </td>
          </tr>
          <tr>
            <td>Freight Info (if available)</td>
            <td>
              <FreightBookingByVin vin={veh?.VEHVIN} />
            </td>
          </tr>
          <tr>
            <td>Recon report</td>
            <td>
              <ReconReportComponent
                vin={veh?.VEHVIN}
                stockNumber={veh?.VEHStockNumber}
              />
            </td>
          </tr>

          <tr>
            <td colSpan={2}>
              <VehiclePhotos stockNumber={veh?.VEHStockNumber} />
            </td>
          </tr>
        </tbody>
      </Table>
      <Table striped bordered hover size="sm">
        <tbody style={{ fontSize: 12 }}>
          <tr>
            <td colSpan={6}>
              <h6
                style={{
                  backgroundColor: "#D4E6F1",
                  color: "black",
                  textAlign: "center",
                  margin: 0,
                  padding: 5,
                }}
              >
                Yard changes
              </h6>
            </td>
          </tr>
          <tr style={{ fontWeight: "bold" }}>
            <td>Branch</td>
            <td>Yard location</td>
            <td>Changed by</td>
            <td>Changed date</td>
            <td>Days in yard</td>
          </tr>
          {yardLogs?.map((yl, idxyl) => {
            let daysInYard = 0;
            if (idxyl === yardLogs.length - 1) {
              // If this is the most recent yard log, calculate days in yard from now
              daysInYard = dayjs().diff(
                dayjs.unix(yl.Yard_Change_Date_EPOC),
                "day"
              );
            } else {
              // Otherwise, calculate days in yard from the next yard log change date
              const nextYardChangeDate = dayjs.unix(
                yardLogs[idxyl + 1].Yard_Change_Date_EPOC
              );
              daysInYard = nextYardChangeDate.diff(
                dayjs.unix(yl.Yard_Change_Date_EPOC),
                "day"
              );
            }

            // Ensure daysInYard is at least 0
            daysInYard = Math.max(daysInYard, 0);

            // REVERSE to be most recent change at the top
            return (
              <tr key={idxyl}>
                <td>{yl.Branch}</td>
                <td>{yl.VEHYard}</td>
                <td>{yl.desc}</td>
                <td>
                  {dayjs.unix(yl.Yard_Change_Date_EPOC).format("DD/MM/YYYY")}
                </td>
                <td>{daysInYard}</td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </>
  );
};

export default StockCardSummaryRecon;
